/**
 * 비밀번호 표시/숨김 토글. 버튼에 `data-nx-reveal="#input-id"` 를 달면 동작한다.
 *
 * ★ 부팅 때 한 번 훑어 버튼마다 리스너를 다는 방식이었는데, 그러면 **팝업처럼
 *   나중에 들어온 DOM 은 영영 동작하지 않는다.** document 위임으로 바꾸면
 *   언제 들어오든 상관없고, 리스너도 하나뿐이다.
 */
export function initReveal(): void {
  document.addEventListener('click', (ev) => {
    const btn = (ev.target as HTMLElement | null)?.closest<HTMLElement>('[data-nx-reveal]');
    if (!btn) return;
    const selector = btn.dataset.nxReveal;
    if (!selector) return;
    const input = document.querySelector<HTMLInputElement>(selector);
    if (!input) return;

    const showing = input.type === 'text';
    input.type = showing ? 'password' : 'text';
    btn.setAttribute('aria-pressed', String(!showing));
    const icon = btn.querySelector('i');
    if (icon) {
      icon.classList.toggle('ri-eye-off-line', showing);
      icon.classList.toggle('ri-eye-line', !showing);
    }
  });
}
